import { render, staticRenderFns } from "./LEDPCB65GameBoy.vue?vue&type=template&id=f11683a4&scoped=true&"
import script from "./LEDPCB65GameBoy.vue?vue&type=script&lang=js&"
export * from "./LEDPCB65GameBoy.vue?vue&type=script&lang=js&"
import style0 from "./LEDPCB65GameBoy.vue?vue&type=style&index=0&id=f11683a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11683a4",
  null
  
)

export default component.exports